// extracted by mini-css-extract-plugin
module.exports = {"outer":"_20SJx","textContainer":"_1qxzn","heading":"kikgK","knowMore":"_310DU"};